import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceMetaDataRoutingModule } from './device-metadata-routing.module';
import { DeviceMetadataComponent } from './device-metadata.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    DeviceMetaDataRoutingModule,
    TableModule,
    RadioButtonModule,
    CheckboxModule,
    ButtonModule,
    ToastModule,
    NgbModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    MultiSelectModule
  ],
  declarations: [DeviceMetadataComponent]
})
export class DeviceMetadataModule { }
